import React, {useCallback} from 'react'
import {Stack, Box} from '@sanity/ui'
import {set, unset} from 'sanity'
import {StringInputProps} from 'sanity'
import {BlockPicker, ColorResult} from 'react-color'

interface ColorInputProps extends StringInputProps {
  // Add any additional props if needed
}

// const ColorInput = (props: BlockAnnotationProps) => {
//   return (
//     <>
//       {/* Render the annotated text */}
//       <span onClick={props.onOpen}>{props.textElement}</span>
//       {/* Render the editing form if the object is opened */}
//       {props.open && (
//         <Dialog
//           contentEditable={false} // Attribute this as non-editable to the text editor
//           header={`Edit ${props.schemaType.title}`}
//           id={`dialog-${props.value._key}`}
//           onClickOutside={props.onClose}
//           onClose={props.onClose}
//         >
//           <Box margin={2} padding={2}>
//             {props.children}
//           </Box>
//         </Dialog>
//       )}
//     </>
//   )
// }

const ColorInput = ({value, onChange}: ColorInputProps) => {
  // Creates a change handler for patching data
  const handleChange = useCallback(
    (colorResult: ColorResult) => {
      onChange(colorResult?.hex ? set(colorResult.hex) : unset())
    },
    [onChange],
  )

  return (
    <Stack gap={3}>
      <Box>
        <BlockPicker
          color={value || '#FFFFFF'}
          triangle="hide"
          colors={[
            '#FFFFFF',
            '#000000',
            '#F93B21',
            '#0196F2',
            '#202020',
            '#3C3C3C',
            '#808080',
            '#DFDFDF',
            '#3b7cc0',
            '#f08122',
            '#e43d30',
            '#00bc70',
          ]}
          width={296}
          onChange={handleChange}
        />
      </Box>
    </Stack>
  )
}

export default ColorInput
